import React, { PropTypes } from 'react';
import ClubEditForm from '../ClubEditForm';

class ClubNewComponent extends React.Component {
  static propTypes = {
    model: PropTypes.object
  };

  render() {
    return (
      <div>
        <h1>Create new account</h1>
        <ClubEditForm />
      </div>
    );
  }
}

export default ClubNewComponent;




// WEBPACK FOOTER //
// ./src/components/Clubs/ClubNew/component.jsx